module.exports = __webpack_public_path__ + "img/ascend_gold32.4bfca0b7.png";